const STORAGE_KEY = 'interview_id';

export function getInterviewId() {
  return localStorage.getItem(STORAGE_KEY);
}

export function setInterviewId(id) {
  localStorage.setItem(STORAGE_KEY, id);
}

/** 优先从 URL 读取 id 并写入 storage，否则返回已存储的 id */
export function resolveInterviewId() {
  const fromUrl = new URLSearchParams(window.location.search).get('id');
  if (fromUrl) {
    setInterviewId(fromUrl);
    return fromUrl;
  }
  return getInterviewId();
}
